import { render, staticRenderFns } from "./CoSyncListItemStatus.vue?vue&type=template&id=ab979fbc&scoped=true&"
import script from "./CoSyncListItemStatus.vue?vue&type=script&lang=ts&"
export * from "./CoSyncListItemStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncListItemStatus.vue?vue&type=style&index=0&id=ab979fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab979fbc",
  null
  
)

export default component.exports